// @flow weak

import localforage from 'localforage';
import * as R from 'ramda';

import { BridgeService, HttpService } from './';
import { ApolloService, TokenService } from '~/services';
import { ROUTER_ACTION_REFRESH, STORAGE_KEY_ELEVATE_TOKENS } from '~/helpers';
import { MUTATION_ROUTER_TRIGGER_ACTION, QUERY_ROUTER_TRIGGER } from '../gql';

let request = {};

export const getAuthTokens = async () => {
  const promise = new Promise((resolve, reject) => {
    request.resolve = authTokens => {
      resolve(authTokens);
    };
    request.reject = error => {
      reject(error);
    };
  });

  return await BridgeService.getAuthTokens(promise);
};

export const getElevateTokens = async () => {
  const elevateTokens = await localforage.getItem(STORAGE_KEY_ELEVATE_TOKENS);

  if (!elevateTokens) {
    return;
  }

  const isTokenExpired = TokenService.isTokenExpired(elevateTokens.accessToken);

  if (isTokenExpired) {
    await localforage.removeItem(STORAGE_KEY_ELEVATE_TOKENS);

    return;
  }

  return elevateTokens;
};

export const resolveGetAuthTokens = async authTokens => {
  if (!authTokens) {
    HttpService.removeAuthorizationToken();

    return;
  }

  HttpService.setAuthorizationToken(authTokens.accessToken);

  if (R.isEmpty(request)) {
    await ApolloService.client.mutate({
      mutation: MUTATION_ROUTER_TRIGGER_ACTION,
      refetchQueries: [{ query: QUERY_ROUTER_TRIGGER }],
      variables: {
        action: ROUTER_ACTION_REFRESH,
      },
    });
  } else {
    request.resolve(authTokens);
    request = {};
  }
};

export const setElevateTokens = async elevateTokens => {
  if (!elevateTokens || R.isEmpty(elevateTokens)) {
    await localforage.removeItem(STORAGE_KEY_ELEVATE_TOKENS);

    return;
  }

  const isTokenExpired = TokenService.isTokenExpired(elevateTokens.accessToken);

  if (isTokenExpired) {
    await localforage.removeItem(STORAGE_KEY_ELEVATE_TOKENS);

    return;
  }

  await localforage.setItem(STORAGE_KEY_ELEVATE_TOKENS, elevateTokens);
};

export const changeEmail = async () => BridgeService.changeEmail();
export const changePassword = async () => BridgeService.changePassword();
export const elevate = async draftId => BridgeService.getElevateTokens(draftId);
export const setupMfa = async () => BridgeService.setupMfa();
export const signIn = async () => BridgeService.signIn();
export const signOut = async () => BridgeService.signOut();
